import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsType } from '../../components';
import { ACTIVE_TAB_PARAM } from '../../constants';
import { useAppSelector } from '../../hooks';
import { AnalyticsTab, Permissions } from '../../types';
import { conditionalArray } from '../../utils';
import ActivityTab from './ActivityTab';
import ProgressReportTab from './ProgressReportTab';
import TeamPerformanceTab from './TeamPerformanceTab';

const DEFAULT_ACTIVE_TAB = AnalyticsTab.ACTIVITY;

const AnalyticsPage = () => {
  const user = useAppSelector((state) => state.auth.user);
  const canViewTeamPerformance = !!user?.permissions?.includes(Permissions.VIEW_TEAM_ANALYTICS);

  const [searchParams, setSearchParams] = useSearchParams();

  const currentTabFromParams = searchParams.get(ACTIVE_TAB_PARAM);
  const activeTab = currentTabFromParams || DEFAULT_ACTIVE_TAB;

  const tabs = useMemo(
    () => [
      {
        id: AnalyticsTab.ACTIVITY,
        title: 'Activity',
        content: <ActivityTab />,
      },

      ...conditionalArray(canViewTeamPerformance, {
        id: AnalyticsTab.TEAM_PERFORMANCE,
        title: 'Team performance',
        content: <TeamPerformanceTab />,
      }),
      {
        id: AnalyticsTab.PROGRESS_REPORT,
        title: 'Progress report',
        content: <ProgressReportTab />,
      },
    ],
    [canViewTeamPerformance]
  );

  const updateTabInParams = useCallback(
    (newActiveTab: string) =>
      setSearchParams((prev) => ({
        ...prev,
        [ACTIVE_TAB_PARAM]: newActiveTab,
      })),
    [setSearchParams]
  );

  return (
    <div className="h-full w-full pl-8 pr-4 pt-4">
      <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={updateTabInParams} type={TabsType.BORDERED} />
    </div>
  );
};

export default AnalyticsPage;
